import RelatedDocumentsBodyNavMenu from './RelatedDocumentsBodyNavMenu'

export default RelatedDocumentsBodyNavMenu



// WEBPACK FOOTER //
// ./src/modules/RelatedDocuments/RelatedDocumentsBodyNavMenu/index.js